import { useState, useEffect, useRef } from "react";
// import ErrorMsg from "./error-msg";
// import Description from "./description";
// import Input from "./input";
import TextField from "../../audi-ui-components/TextField";
import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { add } from "lodash";

// https://developers.google.com/maps/documentation/javascript/examples/places-autocomplete-addressform

const WrappedAddressField = ({
  values, errors, touched,
  setFieldValue, setFieldTouched,
  onFocus = ()=>{},
  theme,
  addressKey = "address",
  suburbKey = "suburb",
  postcodeKey = "postCode",
}) => {
  //
  const [inputValue, setInputValue] = useState("");
  const autoCompleteRef = useRef(null);
  const inputRef = useRef(null);

  const processAddressComponents = (place) => {
    if (place && place.address_components) {
      let addressComponents = {
        addressFull: "",
        address: "",
        postcode: "",
        suburb: "",
      };
      if (place && place.formatted_address) {
        addressComponents.addressFull = place.formatted_address;
      }
      for (let component of place.address_components) {
        let componentType = component.types[0];
        switch (componentType) {
          case "street_number": {
            addressComponents.address = `${component.long_name} ${addressComponents.address}`;
            break;
          }
          case "route": {
            addressComponents.address += component.short_name;
            break;
          }
          case "postal_code": {
            addressComponents.postcode = component.long_name;
            break;
          }
          case "locality": {
            addressComponents.suburb = component.long_name;
            break;
          }
        }
      }
      return addressComponents;
    }
    return null;
  };

  const handlePlaceChanged = () => {
    let place = autoCompleteRef.current.getPlace();
    // console.log(place);
    if (place && place.address_components) {
      let addressComponents = processAddressComponents(place);
      if (addressComponents?.addressFull && addressComponents?.address) {
        setInputValue(addressComponents.addressFull);
        setFieldValue(addressKey, addressComponents.address);
        setFieldValue(suburbKey, addressComponents.suburb);
        setFieldValue(postcodeKey, addressComponents.postcode);
      }
    }
  };

  useEffect(() => {
    autoCompleteRef.current = new google.maps.places.Autocomplete(
      inputRef.current,
      {
        componentRestrictions: { country: ["AU"] },
        fields: ["address_components", "formatted_address"],
        types: ["address"],
      },
    );
    autoCompleteRef.current.addListener("place_changed", handlePlaceChanged);
    // eslint-disable-next-line
  }, []);

  return (
    <div>
      <TextField name="fulladdress"
        label="Address"
        placeholder=""
        value={inputValue || ""}
        onChange={(v) => {
          if (values.address) {
            setFieldValue(addressKey, "");
            setFieldValue(suburbKey, "");
            setFieldValue(postcodeKey, "");
          }
          setInputValue(v);
        }}
        onBlur={() => {
          if (!values.address) {
            handlePlaceChanged();
          }
          setFieldTouched(addressKey);
          setFieldTouched(suburbKey);
          setFieldTouched(postcodeKey);
        }}
        onFocus={onFocus}
        isInvalid={(errors[addressKey] || errors[suburbKey] || errors[postcodeKey]) && touched[addressKey]}
        invalidMessage={errors[addressKey] || errors[suburbKey] || errors[postcodeKey]}
        className="form-field"
        theme={theme === "dark" ? "light" : null}
        ref={inputRef}
      />
    </div>
  );
};

const FallbackFields = ({
  values, errors, touched,
  setFieldValue, setFieldTouched,
  theme,
  addressKey = "address",
  suburbKey = "suburb",
  postcodeKey = "postCode",
}) => {
  return (<>
    <TextField name={addressKey}
      label="Address"
      value={values[addressKey]}
      onChange={(v) => { setFieldValue(addressKey, v); }}
      isInvalid={errors[addressKey] && touched[addressKey]}
      invalidMessage={errors[addressKey]}
      onBlur={() => { setFieldTouched(addressKey); }}
      className="form-field"
      theme={theme === "dark" ? "light" : null}
    />
    <div className="row">
      <div className="col-12 col-small-6 col-medium-12 col-large-6">
        <TextField name={suburbKey}
          label="Suburb"
          value={values[suburbKey]}
          onChange={(v) => { setFieldValue(suburbKey, v); }}
          isInvalid={errors[suburbKey] && touched[suburbKey]}
          invalidMessage={errors[suburbKey]}
          onBlur={() => { setFieldTouched(suburbKey); }}
          className="form-field"
          theme={theme === "dark" ? "light" : null}
        />
      </div>
      <div className="col-12 col-small-6 col-medium-12 col-large-6">
        <TextField name={postcodeKey}
          label="Postcode"
          value={values[postcodeKey]}
          onChange={(v) => { setFieldValue(postcodeKey, v.trim()); }}
          isInvalid={errors[postcodeKey] && touched[postcodeKey]}
          invalidMessage={errors[postcodeKey]}
          onBlur={() => { setFieldTouched(postcodeKey); }}
          className="form-field"
          theme={theme === "dark" ? "light" : null}
        />
      </div>
    </div>
  </>);
};

const AddressField = (props) => {
  return (
    <Wrapper
      apiKey={process.env.RAZZLE_GOOGLE_MAPS_API_KEY}
      libraries={["places"]}
      render={(status) => {
        if (status === Status.FAILURE) {
          return <FallbackFields {...props} />;
        }
        return null;
      }}
    >
      <WrappedAddressField {...props} />
    </Wrapper>
  );
};

export default AddressField;
